import React from 'react';
import Card from '../../ui/Card';
const CapacityGauge: React.FC = () => {
  const utilization = 78;
  return <Card className="p-6" data-id="element-8288">
      <h3 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-8289">
        Plant Capacity Utilization
      </h3>
      <div className="flex items-center justify-center py-6" data-id="element-8290">
        <div className="relative w-48 h-48" data-id="element-8291">
          <svg className="transform -rotate-90 w-48 h-48" data-id="element-8292">
            <circle cx="96" cy="96" r="88" stroke="#e5e7eb" strokeWidth="12" fill="none" data-id="element-8293" />
            <circle cx="96" cy="96" r="88" stroke="#3b82f6" strokeWidth="12" fill="none" strokeDasharray={`${utilization / 100 * 553} 553`} strokeLinecap="round" data-id="element-8294" />
          </svg>
          <div className="absolute inset-0 flex items-center justify-center flex-col" data-id="element-8295">
            <span className="text-4xl font-bold text-gray-800" data-id="element-8296">
              {utilization}%
            </span>
            <span className="text-sm text-gray-600 mt-1" data-id="element-8297">Utilized</span>
          </div>
        </div>
      </div>
      <div className="mt-4 pt-4 border-t border-gray-200" data-id="element-8298">
        <div className="flex justify-between text-sm" data-id="element-8299">
          <span className="text-gray-600" data-id="element-8300">Available Capacity</span>
          <span className="font-semibold text-gray-800" data-id="element-8301">22%</span>
        </div>
      </div>
    </Card>;
};
export default CapacityGauge;